const modalChangePassword = {
  header: 'שנה סיסמה',
  currentPassword: 'סיסמה נוכחית',
  newPassword: 'סיסמה חדשה',
  confirmPassword: 'אשר סיסמה',
  buttonSubmit: 'אשר',
  validation: {
    required: 'סיסמה נדרשת',
    leastCharacters: 'הסיסמה חייבת להיות לפחות 6 תווים',
    criteria: 'צריך להכיל אותיות קטנות וגדולות',
    mustMatch: 'הסיסמאות חייבות להתאים',
    confirmRequired: 'אישור סיסמה נדרש',
  },
};

export default modalChangePassword;
